var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C6.9595 0 0 6.9595 0 15.5C0 24.0405 6.9595 31 15.5 31C24.0405 31 31 24.0405 31 15.5C31 6.9595 24.0405 0 15.5 0Z",
    fill: "#FF7975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4972 1.40869C7.73307 1.40869 1.40625 7.73551 1.40625 15.4996C1.40625 23.2637 7.73307 29.5905 15.4972 29.5905C23.2612 29.5905 29.5881 23.2637 29.5881 15.4996C29.5881 7.73551 23.2612 1.40869 15.4972 1.40869Z",
    fill: "#EE443F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5012 5.63623C16.5579 5.63623 16.9102 6.46159 16.9102 7.04522L16.5579 18.3171C16.5579 18.9007 16.0848 19.3738 15.5012 19.3738C14.9175 19.3738 14.4444 18.9007 14.4444 18.3171L14.0922 7.04522C14.0922 6.46159 14.4444 5.63623 15.5012 5.63623Z",
    fill: "#FFBAB8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2607 22.5453C17.2607 23.518 16.4722 24.3065 15.4995 24.3065C14.5268 24.3065 13.7383 23.518 13.7383 22.5453C13.7383 21.5726 14.5268 20.7841 15.4995 20.7841C16.4722 20.7841 17.2607 21.5726 17.2607 22.5453Z",
    fill: "#FFB0AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateRejected);
export default __webpack_public_path__ + "static/media/stateRejected.0c761238cdbf5ebbb2fc68c87780f8ea.svg";
export { ForwardRef as ReactComponent };